import { FC, useMemo } from "react";
import { useSelector } from "react-redux";
import { HseContextSelector } from "../../reducers/hseCurrentContext";
import scrollElementIntoView from "../../utils/scrollElementIntoView";
import styled, { useTheme } from "styled-components";
import { NavbarWidget } from "@brg/navbar";
import { FlexBox, useBreakpoint } from "@brg/ui";
import { DropdownWithExternalsLinks } from "../../navbars/components/contextTabsItems";
import { DropdownWrapper } from "../../navbars/HSEDeziiignNavbar";
import { useTranslation } from "react-i18next";
import { LayoutConst } from "core";

const AnchorItem = styled(NavbarWidget.NavBarLinksWidgetItem)`
  font-family: 'Inter';
  font-weight: 600;
  font-size: 17px;
  line-height: 22px;
  white-space: nowrap;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 15px;
    line-height: 20px;
  }

  :before {
    content: '';
    position: absolute;
    height: 30px;
    width: 100%;
  }
`

const DEFAULT_ANCHORS_LIMIT = 3;

const AnchorNavigation: FC = () => {
  const { anchorLinks, anchorsLimit } = useSelector(HseContextSelector);
  const { t } = useTranslation()
  const theme = useTheme();
  const is1440 = useBreakpoint(1400);

  const actualAnchorsLimit = anchorsLimit > DEFAULT_ANCHORS_LIMIT ? DEFAULT_ANCHORS_LIMIT : anchorsLimit

  const visibleLinks = useMemo(() => {
    if (is1440) {
      return []
    }
    return [...anchorLinks].splice(0, actualAnchorsLimit)
  }, [anchorLinks, actualAnchorsLimit, is1440]);

  const hiddenLinks = useMemo(() => {
    const baseLinks = !is1440 ? [...anchorLinks].splice(actualAnchorsLimit, anchorLinks.length) : anchorLinks;
    return baseLinks.map(({ anchorText, postId }) => {
      return {
        title: anchorText,
        name: anchorText,
        value: `#`,
        ctx: '',
        active: false,
        external: false,
        isTeam: false,
        isModal: true,
        action: (e: any) => {

          const element = document.querySelector(`[data-rbd-draggable-id="${postId}"]`)
          if (element) {
            setTimeout(() => {
                scrollElementIntoView(element, -70);
            }, 300)
          }
        }
      }
    })
  }, [anchorLinks, actualAnchorsLimit, is1440])

  return (
    <FlexBox offsetLeft={24}>
      {
        //@ts-ignore
        visibleLinks.map(({ anchorText, postId }) => <AnchorItem
          key={anchorText}
          theme={theme} {...theme.navigationBar.linksHse}
          onClick={() => {
            const element = document.querySelector(`[data-rbd-draggable-id="${postId}"]`)
            if (element) {
              scrollElementIntoView(element, -70);
            }
          }}>
          {anchorText?.toLowerCase()}
        </AnchorItem>
      )}
      {!!hiddenLinks?.length && (
        <DropdownWrapper>
          <DropdownWithExternalsLinks
            maxHeight={460}
            maxWidth={400}
            list={hiddenLinks}
            customTarget={is1440}
            //@ts-ignore
            target={<AnchorItem theme={theme} {...theme.navigationBar.linksHse}>{t('nav.navigation')}</AnchorItem>}
            isCustomTitle
            hoverOpen
            noMargin
          />
        </DropdownWrapper>
      )}
    </FlexBox>
  )
}

export default AnchorNavigation;import { FC, useMemo } from "react";
import { useSelector } from "react-redux";
import { HseContextSelector } from "../../reducers/hseCurrentContext";
import scrollElementIntoView from "../../utils/scrollElementIntoView";
import styled, { useTheme } from "styled-components";
import { NavbarWidget } from "@brg/navbar";
import { FlexBox, useBreakpoint } from "@brg/ui";
import { DropdownWithExternalsLinks } from "../../navbars/components/contextTabsItems";
import { DropdownWrapper } from "../../navbars/HSEDeziiignNavbar";
import { useTranslation } from "react-i18next";
import { LayoutConst } from "core";

const AnchorItem = styled(NavbarWidget.NavBarLinksWidgetItem)`
  font-family: 'Inter';
  font-weight: 600;
  font-size: 17px;
  line-height: 22px;
  white-space: nowrap;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 15px;
    line-height: 20px;
  }

  :before {
    content: '';
    position: absolute;
    height: 30px;
    width: 100%;
  }
`

const DEFAULT_ANCHORS_LIMIT = 3;

const AnchorNavigation: FC = () => {
  const { anchorLinks, anchorsLimit } = useSelector(HseContextSelector);
  const { t } = useTranslation()
  const theme = useTheme();
  const is1440 = useBreakpoint(1400);

  const actualAnchorsLimit = anchorsLimit > DEFAULT_ANCHORS_LIMIT ? DEFAULT_ANCHORS_LIMIT : anchorsLimit

  const visibleLinks = useMemo(() => {
    if (is1440) {
      return []
    }
    return [...anchorLinks].splice(0, actualAnchorsLimit)
  }, [anchorLinks, actualAnchorsLimit, is1440]);

  const hiddenLinks = useMemo(() => {
    const baseLinks = !is1440 ? [...anchorLinks].splice(actualAnchorsLimit, anchorLinks.length) : anchorLinks;
    return baseLinks.map(({ anchorText, postId }) => {
      return {
        title: anchorText,
        name: anchorText,
        value: `#`,
        ctx: '',
        active: false,
        external: false,
        isTeam: false,
        isModal: true,
        action: (e: any) => {

          const element = document.querySelector(`[data-rbd-draggable-id="${postId}"]`)
          if (element) {
            setTimeout(() => {
                scrollElementIntoView(element, -70);
            }, 300)
          }
        }
      }
    })
  }, [anchorLinks, actualAnchorsLimit, is1440])

  return (
    <FlexBox offsetLeft={24}>
      {
        //@ts-ignore
        visibleLinks.map(({ anchorText, postId }) => <AnchorItem
          key={anchorText}
          theme={theme} {...theme.navigationBar.linksHse}
          onClick={() => {
            const element = document.querySelector(`[data-rbd-draggable-id="${postId}"]`)
            if (element) {
              scrollElementIntoView(element, -70);
            }
          }}>
          {anchorText?.toLowerCase()}
        </AnchorItem>
      )}
      {!!hiddenLinks?.length && (
        <DropdownWrapper>
          <DropdownWithExternalsLinks
            maxHeight={460}
            maxWidth={400}
            list={hiddenLinks}
            customTarget={is1440}
            //@ts-ignore
            target={<AnchorItem theme={theme} {...theme.navigationBar.linksHse}>{t('nav.navigation')}</AnchorItem>}
            isCustomTitle
            hoverOpen
            noMargin
          />
        </DropdownWrapper>
      )}
    </FlexBox>
  )
}

export default AnchorNavigation;